import {
    ChangeDetectorRef,
    Component,
    Input,
    ViewEncapsulation,
    ElementRef,
    HostBinding,
} from "@angular/core"

@Component({
    selector: "app-modal",
    template: ` <div
        [class]="
            'modal-dialog' +
            (size ? ' modal-' + size : '') +
            (scrollable ? ' modal-dialog-scrollable' : '')
        "
        role="document"
    >
        <div class="modal-content"><ng-content></ng-content></div>
    </div>`,
    encapsulation: ViewEncapsulation.None,
    host: {
        style: "display: block",
    },
})
export class ModalComponent {
    @HostBinding("role") role = "dialog"
    @HostBinding("tabindex") tabindex = "-1"
    @HostBinding("class") get class() {
        return `modal ${this.windowClass ? this.windowClass : ""}`
    }

    @Input() public id: string
    @Input() size: string
    @Input() scrollable: string
    @Input() windowClass: string

    constructor(public changeDetectorRef: ChangeDetectorRef, public elementRef: ElementRef) {}
}
